import './styles.scss'

import { Divider } from 'antd'
import type { FormInstance } from 'antd'

import ButtonsWrapperComponent from '../components/ButtonsWrapper'
import LowerSection from './LowerSection'
import MiddleSection from './MiddleSection'
import UpperSection from './UpperSection'

interface StepThreeComponentProps {
  form: FormInstance
  tab?: number
  setTabHandler?: (...args: unknown[]) => unknown
  submitFormHandler?: (...args: unknown[]) => unknown
}

const StepThreeComponent = (props: StepThreeComponentProps) => {
  const { form, tab = 1, setTabHandler, submitFormHandler } = props
  return (
    <div className="step-three__wrapper">
      <div className="order-overview__wrapper">
        <UpperSection form={form} submitFormHandler={submitFormHandler} />
        <div className="order-overview__divider fw-container">
          <Divider className="divider--thin" />
        </div>
        <MiddleSection />
        <LowerSection form={form} />
      </div>

      <div className="checkout__bottom-space" />
      <div className="fw-container">
        <ButtonsWrapperComponent
          form={form}
          setTabHandler={setTabHandler}
          submitFormHandler={submitFormHandler}
          tab={tab}
        />
      </div>
    </div>
  )
}

export default StepThreeComponent
